"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  BusinessPiggyBankBroken: ['business-piggy-bank-broken', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.5,11.251H2.816a.252.252,0,0,1,.215.122,7.317,7.317,0,0,0,2.354,2.4.248.248,0,0,1,.115.211v2.772a1,1,0,0,0,2,0v-1.5a.25.25,0,0,1,.107-.205.247.247,0,0,1,.229-.03,12.279,12.279,0,0,0,4.2.732,12.243,12.243,0,0,0,3.641-.543.25.25,0,0,1,.324.239v1.3a1,1,0,1,0,2,0V14.32a.25.25,0,0,1,.119-.213,7.358,7.358,0,0,0,3.567-4.789.253.253,0,0,1,.174-.194A3,3,0,0,0,24,6.251a1,1,0,0,0-2,0,1.017,1.017,0,0,1-.014.167.25.25,0,0,1-.485.035A8.5,8.5,0,0,0,15.763,1.32a.252.252,0,0,0-.27.08L13.245,4.147a.441.441,0,0,0-.011.543l2.225,2.967a.439.439,0,0,1-.014.546l-4.491,5.39a.44.44,0,0,1-.744-.453l2.262-5.371a.441.441,0,0,0-.094-.483L10.129,5.037a.439.439,0,0,1-.112-.432l.992-3.471a.25.25,0,0,0-.048-.229.255.255,0,0,0-.217-.089A12.215,12.215,0,0,0,8.6,1.231a.249.249,0,0,1-.24-.057A3.464,3.464,0,0,0,4.311.691a.5.5,0,0,0,0,.874A2.328,2.328,0,0,1,5.278,2.6.249.249,0,0,1,5.2,2.9a7.287,7.287,0,0,0-2.823,4.16.249.249,0,0,1-.241.187H.5a.5.5,0,0,0-.5.5v3A.5.5,0,0,0,.5,11.251Zm5.642-5.5A1.169,1.169,0,1,1,5,6.92,1.158,1.158,0,0,1,6.142,5.751Z', 'M0.000 22.251 A3 1.5 0 1 0 6.000 22.251 A3 1.5 0 1 0 0.000 22.251 Z', 'M7.000 20.251 A3 1.5 0 1 0 13.000 20.251 A3 1.5 0 1 0 7.000 20.251 Z', 'M17.000 22.251 A3 1.5 0 1 0 23.000 22.251 A3 1.5 0 1 0 17.000 22.251 Z']],
  BusinessBigSmallFish: ['business-big-small-fish', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.55,9.4a.5.5,0,0,0,.138-.641C14.443,6.505,12.612,5.5,9.75,5.5A6.475,6.475,0,0,0,3.732,9.548a.249.249,0,0,1-.42.07l-.806-.93A1,1,0,0,0,.75,9.342v5.316a1,1,0,0,0,1.756.654l.806-.93a.249.249,0,0,1,.42.07A6.473,6.473,0,0,0,9.75,18.5a6.34,6.34,0,0,0,5.928-3.241.5.5,0,0,0-.128-.658l-3.2-2.4a.249.249,0,0,1,0-.4Zm-3.8-.15a.75.75,0,1,1,.75-.75A.75.75,0,0,1,11.75,9.25Z', 'M17.514,13.507a.5.5,0,0,0,.513-.026L19.1,12.77a.248.248,0,0,1,.205-.033.255.255,0,0,1,.159.132,2,2,0,1,0,0-1.738.255.255,0,0,1-.159.132.248.248,0,0,1-.205-.033l-1.068-.711a.5.5,0,0,0-.777.416v2.13A.5.5,0,0,0,17.514,13.507Z']],
  BusinessBoatSuccess: ['business-boat-success', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.542,3.6A1.888,1.888,0,0,0,20.38,2.078a.251.251,0,0,1-.3-.167,2,2,0,0,0-3.658-.39.251.251,0,0,1-.29.088,1.584,1.584,0,0,0-2.215,1.514s0,1.917,2.4,1.917h4.313C22.062,5.04,22.542,4.561,22.542,3.6Z', 'M8.024,11.639h8.253a.25.25,0,0,0,.193-.409L12.551,6.439a.519.519,0,0,0-.8,0L7.83,11.23a.251.251,0,0,0,.194.409Z', 'M2.492,13.194a.552.552,0,0,0-.018.541L4.7,18.022a.25.25,0,0,0,.208.135,2.488,2.488,0,0,1,1.747.936.242.242,0,0,0,.193.08.235.235,0,0,0,.181-.1l3.99-5.751a.25.25,0,0,0-.206-.392H2.964A.552.552,0,0,0,2.492,13.194Z', 'M8.646,20.146a1.5,1.5,0,0,0,1.264-.693l.008-.014a2.342,2.342,0,0,1,1.874-1.226,2.4,2.4,0,0,1,2.074.909l.01.013a3.074,3.074,0,0,0,1.957,1.011,1.531,1.531,0,0,0,.183-.01.251.251,0,0,0,.2-.144.247.247,0,0,0-.021-.245L12.2,13.891a.249.249,0,0,0-.412,0L7.815,19.617a.254.254,0,0,0-.034.214.25.25,0,0,0,.146.16A1.907,1.907,0,0,0,8.646,20.146Z', 'M17.117,19.215a.25.25,0,0,0,.206-.1,2.336,2.336,0,0,1,1.663-.909.6.6,0,0,1,.095,0,.25.25,0,0,0,.237-.136l2.216-4.339a.553.553,0,0,0-.492-.8H13.178a.25.25,0,0,0-.206.391l3.945,5.787A.25.25,0,0,0,17.117,19.215Z', 'M.021,22.542a.957.957,0,0,0,.958.958,5.51,5.51,0,0,0,3.773-1.322.25.25,0,0,1,.319-.01A5.938,5.938,0,0,0,8.646,23.5a4.731,4.731,0,0,0,3.3-1.3.251.251,0,0,1,.324-.014A5.859,5.859,0,0,0,15.833,23.5a4.7,4.7,0,0,0,3.293-1.273.25.25,0,0,1,.325-.014,5.784,5.784,0,0,0,3.57,1.287.958.958,0,1,0,0-1.916,4.246,4.246,0,0,1-3.067-1.534.943.943,0,0,0-.846-.375.966.966,0,0,0-.774.514,2.839,2.839,0,0,1-2.5,1.395,4.5,4.5,0,0,1-3.085-1.558.946.946,0,0,0-.83-.351.964.964,0,0,0-.76.493,2.952,2.952,0,0,1-2.512,1.416,4.666,4.666,0,0,1-3.1-1.569l0,0a.966.966,0,0,0-1.585.173,3.254,3.254,0,0,1-2.983,1.4A.957.957,0,0,0,.021,22.542Z']],
  BusinessCrossroad: ['business-crossroad', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.293,15.207l2.5,2.5A.993.993,0,0,0,3.5,18H10a.5.5,0,0,1,.5.5v5a.5.5,0,0,0,.5.5h2a.5.5,0,0,0,.5-.5v-5A.5.5,0,0,1,14,18h6a1,1,0,0,0,1-1V12a1,1,0,0,0-1-1H14a.5.5,0,0,1-.5-.5v-1A.5.5,0,0,1,14,9h6.5a.993.993,0,0,0,.707-.293l2.5-2.5a1,1,0,0,0,0-1.414l-2.5-2.5A.993.993,0,0,0,20.5,2H14a.5.5,0,0,1-.5-.5,1.5,1.5,0,0,0-3,0A.5.5,0,0,1,10,2H4A1,1,0,0,0,3,3V8A1,1,0,0,0,4,9h6a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5H3.5a.993.993,0,0,0-.707.293l-2.5,2.5A1,1,0,0,0,.293,15.207Z']],
  BusinessMagicRabbit: ['business-magic-rabbit', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.458,17H7.314a.252.252,0,0,1,.248.286L6.9,21.947a1.3,1.3,0,0,0,.386,1.113,1.571,1.571,0,0,0,1.1.44h6.91a1.577,1.577,0,0,0,1.1-.44,1.305,1.305,0,0,0,.385-1.113h0l-.666-4.66A.252.252,0,0,1,16.362,17h2.18a1,1,0,0,0,0-2H5.458a1,1,0,1,0,0,2Z', 'M20,3.909c1.5-1.5-1-4.5-3-3-.915.687-2.961,3.853-3.712,5.04a.251.251,0,0,1-.278.108,3.52,3.52,0,0,0-2.02,0,.251.251,0,0,1-.278-.108C9.961,4.762,7.915,1.6,7,.909c-2-1.5-4.5,1.5-3,3,.783.783,3.4,2.789,4.5,3.623a.251.251,0,0,1,.064.327,4,4,0,1,0,6.87,0,.25.25,0,0,1,.064-.327C16.6,6.7,19.217,4.692,20,3.909ZM10.25,10.5A.75.75,0,1,1,11,9.75.749.749,0,0,1,10.25,10.5Zm3.5,0a.75.75,0,1,1,.75-.75A.749.749,0,0,1,13.75,10.5Z']],
  BusinessLadder: ['business-ladder', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.691,23.921a1.614,1.614,0,0,0,2.032-1.036L23.6,3.373a1.613,1.613,0,0,0-3.068-1l-.5,1.431a.251.251,0,0,1-.265.165l-9.294-1.12a.25.25,0,0,1-.206-.332l.146-.406a1.613,1.613,0,1,0-3.068-1L.4,20.44a1.613,1.613,0,0,0,3.068,1l.343-.956a.25.25,0,0,1,.26-.164l9.476.944a.251.251,0,0,1,.211.332l-.1.294A1.614,1.614,0,0,0,14.691,23.921ZM9.4,4.932a.247.247,0,0,1,.265-.163L18.97,5.89a.245.245,0,0,1,.183.116.25.25,0,0,1,.023.215l-.963,2.731a.079.079,0,0,1-.082.053L8.605,8.054a.251.251,0,0,1-.211-.333ZM7.523,10.146a.252.252,0,0,1,.26-.165l9.409.94a.253.253,0,0,1,.186.115.248.248,0,0,1,.024.217l-.951,2.7a.251.251,0,0,1-.263.165l-9.407-.993a.249.249,0,0,1-.208-.333ZM4.893,18.39a.251.251,0,0,1-.21-.333L5.7,15.216a.249.249,0,0,1,.261-.164l9.423,1a.249.249,0,0,1,.209.331l-.982,2.789a.249.249,0,0,1-.26.165Z']],
  BusinessLuckyCat: ['business-lucky-cat', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,11.263a4.159,4.159,0,0,0,1.409,2.959.5.5,0,0,0,.348.141.521.521,0,0,0,.146-.021.5.5,0,0,0,.344-.375A14.688,14.688,0,0,1,3.514,10.3l.43-.82A.5.5,0,0,0,4,9.246v-4A1.061,1.061,0,0,0,2.982,4.218,2.766,2.766,0,0,0,1.8,4.395,2.638,2.638,0,0,0,0,6.763Z', 'M20.6,10.579a.5.5,0,0,0-.64.652,16.022,16.022,0,0,1,1.12,5.546,8.345,8.345,0,0,1-.411,2.654.5.5,0,0,0,.726.59,5.245,5.245,0,0,0-.795-9.442Z', 'M11.5,23.237c4.463,0,8.081-2,8.081-6.465a14.662,14.662,0,0,0-1.2-5.43.507.507,0,0,0-.326-.28.5.5,0,0,0-.422.077A6.141,6.141,0,0,1,14,12.237H9a6.138,6.138,0,0,1-3.632-1.1.5.5,0,0,0-.748.2,14.664,14.664,0,0,0-1.2,5.43C3.419,21.234,7.037,23.237,11.5,23.237Zm0-10a1.5,1.5,0,0,1,.9,2.7.251.251,0,0,1-.4-.2v-.494a.5.5,0,0,0-1,0v.493a.251.251,0,0,1-.4.2,1.5,1.5,0,0,1,.9-2.695Z', 'M16.753.831a.5.5,0,0,0-.5,0L12.963,2.682a.256.256,0,0,1-.139.031c-.223-.015-.9-.056-1.324-.056h0c-.423,0-1.1.042-1.325.056a.242.242,0,0,1-.137-.03L6.762.88A.5.5,0,0,0,6.256.869.5.5,0,0,0,6,1.305v2.9a.242.242,0,0,1-.031.121A4.222,4.222,0,0,0,5,7.034a3.761,3.761,0,0,0,4,3.729h5a3.761,3.761,0,0,0,4-3.729,4.216,4.216,0,0,0-.969-2.707A.253.253,0,0,1,17,4.206V1.263A.5.5,0,0,0,16.753.831ZM9.976,6.667a.49.49,0,0,1-.254.07.5.5,0,0,1-.43-.246A1.509,1.509,0,0,0,8,5.755a.5.5,0,0,1,0-1,2.514,2.514,0,0,1,2.152,1.227A.5.5,0,0,1,9.976,6.667ZM15,5.755a1.509,1.509,0,0,0-1.292.736.5.5,0,0,1-.43.246.49.49,0,0,1-.254-.07.5.5,0,0,1-.176-.685A2.514,2.514,0,0,1,15,4.755a.5.5,0,0,1,0,1Z']],
  BusinessMoneyBasket: ['business-money-basket', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.306,23.88a.835.835,0,0,0,.156.013.964.964,0,0,0,.95-.809l.707-4.338,0-.015a1.6,1.6,0,0,0-.469-1.511,2.049,2.049,0,0,0-1.42-.553H3.385a2.05,2.05,0,0,0-1.422.555A1.6,1.6,0,0,0,1.5,18.731l0,.015.706,4.338a.964.964,0,0,0,1.9-.31l-.634-3.889a.249.249,0,0,1,.247-.29H5.9a.25.25,0,0,1,.249.227l.381,4.194a.963.963,0,0,0,.959.876l.088,0a.965.965,0,0,0,.872-1.047L8.09,18.869a.25.25,0,0,1,.249-.272H11.1a.249.249,0,0,1,.249.25V22.93a.964.964,0,0,0,1.927,0V18.849a.249.249,0,0,1,.25-.25H16.76a.25.25,0,0,1,.249.272l-.361,3.971a.965.965,0,0,0,.872,1.047c.03,0,.059,0,.089,0a.963.963,0,0,0,.958-.876l.381-4.189A.25.25,0,0,1,19.2,18.6h1.7a.248.248,0,0,1,.247.29l-.633,3.882A.963.963,0,0,0,21.306,23.88Z', 'M22.9,10.366,18.937,1.339A2.07,2.07,0,0,0,16.21.283L2.072,6.527A2.071,2.071,0,0,0,1.016,9.254l2.409,5.453a.962.962,0,0,0,.882.575A.979.979,0,0,0,4.7,15.2a.964.964,0,0,0,.492-1.27L2.779,8.476a.14.14,0,0,1,.072-.186L16.989,2.046a.14.14,0,0,1,.185.069l3.967,9.029a.139.139,0,0,1-.071.185l-3.837,1.693a.964.964,0,0,0,.779,1.764h0l3.836-1.694a2.069,2.069,0,0,0,1.056-2.725Z', 'M8.849,10.227a2.072,2.072,0,0,0,1.928,1.3h.013l1.852-.011h0a.156.156,0,0,1,.144.1.174.174,0,0,1-.085.2l-.409.167h0l0,0-1.151.469a.964.964,0,0,0,.363,1.856.947.947,0,0,0,.363-.072l.193-.078a.078.078,0,0,1,.06,0,.086.086,0,0,1,.043.043.963.963,0,0,0,.891.6.98.98,0,0,0,.365-.072.963.963,0,0,0,.527-1.256.2.2,0,0,1,.056-.229,2.076,2.076,0,0,0-1.35-3.657h-.013L10.779,9.6h0a.155.155,0,0,1-.058-.3l1.569-.639a.963.963,0,0,0-.726-1.785l-.194.079a.071.071,0,0,1-.059,0,.075.075,0,0,1-.042-.042.963.963,0,0,0-1.785.726L9.5,7.67a.158.158,0,0,1-.045.179A2.079,2.079,0,0,0,8.849,10.227Z']],
  BusinessPaperBoat: ['business-paper-boat', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.693,9.239a.252.252,0,0,0,.187.152l4.03.733a.49.49,0,0,0,.179,0l4.031-.733A.251.251,0,0,0,16.28,9L12.863,4.161a1.11,1.11,0,0,0-1.731.008L7.72,9A.25.25,0,0,0,7.693,9.239Z', 'M18.738,20.1a.25.25,0,0,0-.042-.269l-6.51-7.253A.246.246,0,0,0,12,12.5a.249.249,0,0,0-.186.083L5.3,19.833a.25.25,0,0,0,.186.417H18.51A.252.252,0,0,0,18.738,20.1Z', 'M20.245,19.143A.251.251,0,0,0,20.434,19l3.477-7.822A1.04,1.04,0,0,0,22.775,9.73l-9.129,1.66a.25.25,0,0,0-.142.413l6.516,7.259A.253.253,0,0,0,20.245,19.143Z', 'M.09,11.175l3.474,7.817a.25.25,0,0,0,.415.066L10.5,11.8a.25.25,0,0,0-.141-.413L1.226,9.729A1.041,1.041,0,0,0,.09,11.175Z']],
  BusinessShark1: ['business-shark-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.634,2.439a2.2,2.2,0,0,0-.477,1.394v6.9a.251.251,0,0,0,.29.248,4.381,4.381,0,0,1,3.332.8l.144.108a.251.251,0,0,0,.3,0l.141-.107h0a4.416,4.416,0,0,1,5.27,0l.143.108a.251.251,0,0,0,.3,0l.141-.107h0a4.364,4.364,0,0,1,2.517-.858.25.25,0,0,0,.218-.361A15.526,15.526,0,0,0,7.039,1.9,1.457,1.457,0,0,0,5.634,2.439Z', 'M.582,20.76c.04.029,1.172.878,1.172.879a2.453,2.453,0,0,0,2.928,0l1.17-.879a.491.491,0,0,1,.585,0l1.172.879a2.453,2.453,0,0,0,2.928,0l1.17-.879a.491.491,0,0,1,.585,0l1.172.879a2.453,2.453,0,0,0,2.928,0l1.17-.879a.491.491,0,0,1,.585,0l1.172.879a2.456,2.456,0,0,0,2.928,0l1.171-.879A.976.976,0,0,0,22.246,19.2l-1.17.878a.492.492,0,0,1-.586,0L19.318,19.2a2.45,2.45,0,0,0-2.927,0l-1.17.878a.492.492,0,0,1-.586,0L13.463,19.2a2.45,2.45,0,0,0-2.927,0l-1.17.878a.492.492,0,0,1-.586,0L7.608,19.2a2.45,2.45,0,0,0-2.927,0l-1.171.878a.491.491,0,0,1-.585,0L1.754,19.2A.976.976,0,0,0,.582,20.76Z', 'M3.51,14.223a.492.492,0,0,1-.585,0l-1.171-.879A.976.976,0,0,0,.582,14.9c.04.031,1.172.879,1.172.879a2.45,2.45,0,0,0,2.928,0l1.17-.879a.492.492,0,0,1,.585,0l1.172.879a2.45,2.45,0,0,0,2.928,0l1.17-.879a.492.492,0,0,1,.585,0l1.172.879a2.45,2.45,0,0,0,2.928,0l1.17-.879a.492.492,0,0,1,.585,0l1.172.879a2.448,2.448,0,0,0,2.928,0l1.171-.879a.976.976,0,0,0-1.172-1.56l-1.17.879a.494.494,0,0,1-.586,0l-1.172-.879a2.448,2.448,0,0,0-2.927,0l-1.17.879a.494.494,0,0,1-.586,0l-1.172-.879a2.448,2.448,0,0,0-2.927,0l-1.17.879a.494.494,0,0,1-.586,0l-1.172-.879a2.448,2.448,0,0,0-2.927,0Z']],
  BusinessRabbitHat1: ['business-rabbit-hat-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.216,11.532h7.04a.25.25,0,0,0,.238-.172c.19-.575.407-1.214.636-1.852a.25.25,0,0,1,.333-.146c1,.423,2.256.614,2.846.024,1.088-1.088.537-2.192.094-3.077A5.845,5.845,0,0,0,17,4.042a4.044,4.044,0,0,0-2.771-.385,1.143,1.143,0,0,0-.684.691c-.036.1-.833,2.976-1.487,5.34a.25.25,0,0,1-.486-.016c-.38-1.837-.845-4.005-1.173-5.266C9.976,2.8,9.138,2.353,8.675,2.231a1.861,1.861,0,0,0-1.813.585,3.379,3.379,0,0,0-.62,3.362c.4,1.331,1.133,3.456,1.739,5.186A.248.248,0,0,0,8.216,11.532Z', 'M4.058,14.323a1,1,0,0,0,1,1H6.914a.249.249,0,0,1,.247.285L6.5,20.27a1.3,1.3,0,0,0,.386,1.112,1.574,1.574,0,0,0,1.1.441h6.91a1.571,1.571,0,0,0,1.1-.44,1.3,1.3,0,0,0,.387-1.113h0l-.665-4.661a.249.249,0,0,1,.247-.285h2.1a1,1,0,0,0,0-2h-13A1,1,0,0,0,4.058,14.323Z']],
  BusinessScale: ['business-scale', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,24a1.5,1.5,0,0,0,1.5-1.5V20.25a.25.25,0,0,1,.25-.25h2.4a1.5,1.5,0,0,0,1.479-1.253L19.493,7.521a.3.3,0,0,0,0-.042A7.5,7.5,0,1,0,4.5,7.562a.3.3,0,0,0,0,.041L6.364,18.748A1.5,1.5,0,0,0,7.843,20h2.4a.25.25,0,0,1,.25.25V22.5A1.5,1.5,0,0,0,12,24Zm0-7a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,17ZM7.072,7.422A.251.251,0,0,1,7,7.237a5,5,0,0,1,9.987,0,.251.251,0,0,1-.25.263h-2.4a.25.25,0,0,1-.208-.389l.711-1.065a1,1,0,1,0-1.662-1.111L11.537,7.39a.252.252,0,0,1-.208.11H7.253A.245.245,0,0,1,7.072,7.422ZM8.5,11.75a.75.75,0,0,1,0-1.5h7a.75.75,0,0,1,0,1.5Z']],
  BusinessShark: ['business-shark', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.812,13.76a.156.156,0,0,0,.135.078,2.5,2.5,0,0,1,2.125,1.178,2.115,2.115,0,0,0,1.488.874,2.8,2.8,0,0,0,1.889-1.017,2.5,2.5,0,0,1,4.286.389,1.281,1.281,0,0,0,1.051.628,1.889,1.889,0,0,0,1.449-.8,2.445,2.445,0,0,1,.173-.26,20.034,20.034,0,0,1,2.978-9.461.5.5,0,0,0-.406-.792C11.833,4.576,7.228,9.52,4.814,13.6A.158.158,0,0,0,4.812,13.76Z', 'M22.931,17.379a3.407,3.407,0,0,1-2.677-1.569,1.043,1.043,0,0,0-1.719.028,3.357,3.357,0,0,1-2.749,1.552,2.8,2.8,0,0,1-2.4-1.483,1.043,1.043,0,0,0-1.716-.155,4.306,4.306,0,0,1-3.1,1.638A3.566,3.566,0,0,1,5.8,15.81a1.041,1.041,0,0,0-1.635-.094c-.015.018-1.433,1.823-3.112,1.705A.988.988,0,0,0,0,18.367a1,1,0,0,0,.947,1.052c.074,0,.148.006.221.006a5.708,5.708,0,0,0,3.559-1.463.249.249,0,0,1,.328.007,5.185,5.185,0,0,0,3.5,1.421A5.792,5.792,0,0,0,12.2,18.031a.249.249,0,0,1,.332.016,4.548,4.548,0,0,0,3.258,1.343,5.118,5.118,0,0,0,3.455-1.342.248.248,0,0,1,.334,0,4.7,4.7,0,0,0,3.494,1.325,1,1,0,1,0-.138-2Z']],
  BusinessTrophy: ['business-trophy', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.111,23.75h7.778a1.006,1.006,0,1,0,0-2,.467.467,0,0,1-.34-.157l-.523-.523A3.522,3.522,0,0,1,14,18.594V18.47c0-.1.053-.22.159-.22H15a.75.75,0,0,0,0-1.5H9a.75.75,0,0,0,0,1.5h.782a.222.222,0,0,1,.218.188v.156A3.522,3.522,0,0,1,8.974,21.07l-.547.546a.568.568,0,0,1-.316.134,1.006,1.006,0,1,0,0,2Z', 'M18.5,7.75a.5.5,0,0,0,.5-.5V3.75a.5.5,0,0,0-.5-.5H5.5a.5.5,0,0,0-.5.5v3.5a.5.5,0,0,0,.5.5Zm-2.5-3a.75.75,0,1,1-.75.75A.75.75,0,0,1,16,4.75Zm-4,0a.75.75,0,1,1-.75.75A.75.75,0,0,1,12,4.75Zm-4,0a.75.75,0,1,1-.75.75A.75.75,0,0,1,8,4.75Z', 'M3,1.25a1.035,1.035,0,0,0,1.067,1H19.933A1.035,1.035,0,0,0,21,1.25a1.035,1.035,0,0,0-1.067-1H4.067A1.035,1.035,0,0,0,3,1.25Z', 'M4.5,10.25a1,1,0,0,0,1,1,.385.385,0,0,1,.307.237,6.978,6.978,0,0,0,12.405-.037.337.337,0,0,1,.288-.2,1,1,0,0,0,0-2H5.5A1,1,0,0,0,4.5,10.25Z']],
  BusinessBurnMoney: ['business-burn-money', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M14.267,17.8a1,1,0,0,0,.707-.293l8.233-8.233a2,2,0,0,0,0-2.828L17.55.793a2,2,0,0,0-2.828,0L7.988,7.525A1,1,0,0,0,9.4,8.939l6.557-6.555a.249.249,0,0,1,.353,0l5.3,5.3a.25.25,0,0,1,0,.353L13.56,16.1a1,1,0,0,0,.707,1.707Z', 'M11.707 10.209 A2.000 2.000 0 1 0 15.707 10.209 A2.000 2.000 0 1 0 11.707 10.209 Z', 'M5.461,23.793a5.246,5.246,0,0,0,5.246-5.246,4.957,4.957,0,0,0-1.816-4.041.5.5,0,0,0-.744.2,2.023,2.023,0,0,1-1.9,1.245.251.251,0,0,1-.193-.132,6.012,6.012,0,0,1-.2-5.176.5.5,0,0,0-.674-.659A8.536,8.536,0,0,0,.216,18.547,5.319,5.319,0,0,0,5.461,23.793Zm-.222-6a.382.382,0,0,1,.547.264c.144.694.959,1.387.959,2.155a1.5,1.5,0,0,1-3,0A2.762,2.762,0,0,1,5.239,17.791Z']],
  BusinessFlame: ['business-flame', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.847,17.527H21.153A2.85,2.85,0,0,0,24,14.681c0-.333.076.22-1.35-8.331A2.173,2.173,0,0,0,20.5,4.527H19a1,1,0,0,0,0,2h1.5a.18.18,0,0,1,.178.152c1.4,8.413,1.322,7.9,1.322,8a.848.848,0,0,1-.847.846H2.847A.848.848,0,0,1,2,14.681c0-.1-.081.418,1.322-8A.18.18,0,0,1,3.5,6.527H5a1,1,0,0,0,0-2H3.5A2.173,2.173,0,0,0,1.35,6.35C-.072,14.876,0,14.349,0,14.681A2.85,2.85,0,0,0,2.847,17.527Z', 'M22.5,19.777a1,1,0,0,0-1-1H2.5a1,1,0,0,0,0,2h19A1,1,0,0,0,22.5,19.777Z', 'M3.5,21.777a1,1,0,0,0,0,2h17a1,1,0,0,0,0-2Z', 'M12.412.389a.5.5,0,0,0-.578-.121A8.134,8.134,0,0,0,7,7.527a5,5,0,0,0,10,0,5.213,5.213,0,0,0-2.248-4.3A.5.5,0,0,0,14,3.49a3.9,3.9,0,0,1-.745,1.354.252.252,0,0,1-.182.084.256.256,0,0,1-.186-.078A3.223,3.223,0,0,1,12.471.977.5.5,0,0,0,12.412.389Z']],
  BusinessRabbitHat: ['business-rabbit-hat', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.735,2.127a1.863,1.863,0,0,0-1.815.585A3.38,3.38,0,0,0,6.3,6.073c.445,1.464,1.282,3.885,1.915,5.688a.251.251,0,0,0,.236.167h6.828a.25.25,0,0,0,.233-.16c.206-.533.445-1.153.694-1.806A.22.22,0,0,0,16.12,9.7,4.9,4.9,0,0,1,15,8.731a8.962,8.962,0,0,1-1.943-3.252.068.068,0,0,0-.131,0c-.182.765-.647,2.718-.881,3.754a.249.249,0,0,1-.488,0c-.366-1.758-.794-3.744-1.1-4.928C10.035,2.69,9.2,2.248,8.735,2.127Z', 'M18.651,9.41A1.412,1.412,0,0,0,19.7,7.442,7.879,7.879,0,0,0,16.748,3.9l-.038-.019a4.431,4.431,0,0,0-1.8-.454c-.453,0-.833.126-.957.479-.362,1.036,1.056,3.275,1.812,4.185A3.537,3.537,0,0,0,18.651,9.41Z', 'M4.206,14.428a1,1,0,0,0,1,1H7.061a.25.25,0,0,1,.248.285l-.666,4.661a1.3,1.3,0,0,0,.386,1.112,1.568,1.568,0,0,0,1.1.442h6.911a1.568,1.568,0,0,0,1.1-.442,1.3,1.3,0,0,0,.385-1.112h0l-.666-4.66a.25.25,0,0,1,.248-.285h2.1a1,1,0,0,0,0-2h-13A1,1,0,0,0,4.206,14.428Z']],
  BusinessTeamGoal: ['business-team-goal', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.012.033H17.107a1.725,1.725,0,0,0-1.723,1.722V5.2a.492.492,0,1,1-.984,0V2.251A.25.25,0,0,0,14.15,2H9.725A.738.738,0,0,0,9.2,3.262l1.762,1.761a.252.252,0,0,1,0,.354L9.2,7.139A.737.737,0,0,0,9.725,8.4h7.382a1.724,1.724,0,0,0,1.722-1.721.245.245,0,0,1,.246-.246h2.456a.249.249,0,0,1,.25.25V22.916a.985.985,0,0,0,1.969,0V1.018a.233.233,0,0,0-.011-.065.224.224,0,0,1,0-.115A.247.247,0,0,0,23.75.771.738.738,0,0,0,23.012.033Z', 'M2.471,20.839A4.669,4.669,0,0,0,.282,23.3a.491.491,0,0,0,.46.666H7.308a.25.25,0,0,0,.25-.264c0-.076-.007-.151-.007-.228A6.869,6.869,0,0,1,7.786,21.7a.249.249,0,0,0-.077-.253,4.552,4.552,0,0,0-.964-.643.253.253,0,0,1-.136-.2.248.248,0,0,1,.095-.221,3.448,3.448,0,1,0-5.577-2.707,3.426,3.426,0,0,0,1.378,2.74.25.25,0,0,1-.034.42ZM2.7,17.1a.25.25,0,0,1,.373-.133,4.452,4.452,0,0,0,2.417.716,4.25,4.25,0,0,0,.936-.111.114.114,0,0,1,.094.023.111.111,0,0,1,.042.088,1.978,1.978,0,0,1-3.955,0A1.9,1.9,0,0,1,2.7,17.1Z', 'M12.3,18.289a5.7,5.7,0,0,0-3.354,5.187.492.492,0,0,0,.492.492H19.854a.492.492,0,0,0,.492-.492,5.705,5.705,0,0,0-3.431-5.224.248.248,0,0,1-.15-.208.253.253,0,0,1,.113-.231,3.859,3.859,0,0,0,.623-.5,4.13,4.13,0,1,0-5.928-.094,4.062,4.062,0,0,0,.76.635.246.246,0,0,1,.113.228A.251.251,0,0,1,12.3,18.289Zm3.084,3.264a.738.738,0,1,1-1.476,0V20.342a.738.738,0,0,1,1.476,0ZM11.929,14.41A2.531,2.531,0,0,1,12.1,13.5a.25.25,0,0,1,.16-.149.247.247,0,0,1,.217.035A5.587,5.587,0,0,0,15.7,14.41a5.53,5.53,0,0,0,1.314-.161.166.166,0,0,1,.141.03.17.17,0,0,1,.064.131,2.639,2.639,0,0,1-1.393,2.317,2.646,2.646,0,0,1-3.9-2.317Z']],
  BusinessTripPlane: ['business-trip-plane', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.724,9.956A.249.249,0,0,0,6,9.707V9.583A1.044,1.044,0,0,1,7,8.5h4.5a2.871,2.871,0,0,1,2.445,1.411.246.246,0,0,0,.191.089H17.5A2.065,2.065,0,0,0,19,9h0l.49-.872A.251.251,0,0,1,19.708,8H21a1,1,0,0,0,0-2,.183.183,0,0,1-.16-.272l2.45-4.355a.249.249,0,0,0,0-.249A.252.252,0,0,0,23.072,1H21.5a1.771,1.771,0,0,0-1.5.5l0,0-2.929,2.44a.251.251,0,0,1-.16.058H7C3.615,4,.451,6.492.5,7.462.561,8.623,3.531,9.727,5.724,9.956ZM5,5.385H6.5a.75.75,0,0,1,0,1.5H5a.75.75,0,0,1,0-1.5Z', 'M7.25,9.5A.249.249,0,0,0,7,9.75v1.921a.25.25,0,0,0,.245.25L11.5,12h.012c.534,0,.76,0,1.789-1.193a.086.086,0,0,0,0-.112c-.814-.966-1.036-1.2-1.8-1.2Z', 'M23.5,22V19.75a.25.25,0,0,0-.25-.25H18.5a.25.25,0,0,0-.25.25v.75a.75.75,0,0,1-1.5,0v-.75a.25.25,0,0,0-.25-.25H11.75a.25.25,0,0,0-.25.25V22a1,1,0,0,0,1,1h10A1,1,0,0,0,23.5,22Z', 'M23.5,16a1,1,0,0,0-1-1H21.272a.249.249,0,0,1-.223-.138l-.655-1.309A2.5,2.5,0,0,0,18,12H17a2.5,2.5,0,0,0-2.395,1.553l-.654,1.309a.25.25,0,0,1-.224.138H12.5a1,1,0,0,0-1,1v2.25a.249.249,0,0,0,.25.25h11.5a.249.249,0,0,0,.25-.25Zm-4.81-1.118a.252.252,0,0,1-.213.118H16.522a.249.249,0,0,1-.223-.361l.095-.192C16.618,14,16.729,14,17,14h1c.27,0,.381,0,.605.447l.1.192A.253.253,0,0,1,18.69,14.882Z']],
  BusinessMessageBottle: ['business-message-bottle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.936,2.6a.941.941,0,0,0-.39-1.3L18.4.133a.962.962,0,0,0-1.2.55c-.63,1.35-1.94,4.07-2.26,4.75-.93,1.969-5.311,1.31-7.2,5.33L4.211,18.026a.251.251,0,0,0,.275.354,2.362,2.362,0,0,1,.469-.048,2.507,2.507,0,0,1,2.136,1.194h0a2.112,2.112,0,0,0,1.483.9,1.9,1.9,0,0,0,1.445-.822,2.5,2.5,0,0,1,4.31-.075h0a2.118,2.118,0,0,0,1.484.9A1.9,1.9,0,0,0,17.26,19.6a2.436,2.436,0,0,1,.68-.747.245.245,0,0,0,.079-.1l1.086-2.43c2-4.28-1.559-6.7-.51-8.94C18.976,6.583,20.276,3.973,20.936,2.6ZM14.03,16.581a.25.25,0,0,1-.368.1,3.644,3.644,0,0,0-3.63.074.25.25,0,0,1-.352-.322l2.258-4.863a.251.251,0,0,1,.194-.142.247.247,0,0,1,.224.087,3.919,3.919,0,0,0,1.35,1.015,3.969,3.969,0,0,0,1.69.39.206.206,0,0,1,.186.291ZM16.5,10.893c-.224.5-1.158.744-2.151.28-.9-.423-1.418-1.289-1.159-1.83.312-.627,1.379-.645,2.15-.27C16.449,9.59,16.7,10.484,16.5,10.893Z', 'M19.607,22.563a4.746,4.746,0,0,0,3.208,1.365c.079,0,.16,0,.241-.007a1,1,0,1,0-.113-2,3.42,3.42,0,0,1-2.651-1.612,1.042,1.042,0,0,0-1.727.027,3.368,3.368,0,0,1-2.752,1.583,3.633,3.633,0,0,1-2.762-1.612,1.044,1.044,0,0,0-1.727.029,3.361,3.361,0,0,1-2.75,1.583A3.634,3.634,0,0,1,5.811,20.31a1.04,1.04,0,0,0-1.641-.1c-.015.017-1.464,1.777-3.117,1.706a1,1,0,0,0-.1,2,5.623,5.623,0,0,0,3.779-1.453.251.251,0,0,1,.33.009,5.157,5.157,0,0,0,3.517,1.45,5.082,5.082,0,0,0,3.471-1.373.251.251,0,0,1,.335,0,5.023,5.023,0,0,0,6.89.015A.25.25,0,0,1,19.607,22.563Z']],
  BusinessPearl: ['business-pearl', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.226,12.221c-1.9,1.02-3.476,2.3-3.476,4.279C1.75,20.775,6.157,24,12,24s10.25-3.225,10.25-7.5c0-1.978-1.578-3.259-3.476-4.279a.25.25,0,0,1,0-.441c1.9-1.02,3.476-2.3,3.476-4.28C22.25,3.225,17.843,0,12,0S1.75,3.225,1.75,7.5c0,1.979,1.578,3.26,3.476,4.28a.25.25,0,0,1,0,.441Zm-.312-5.9-.609.375a.251.251,0,0,1-.371-.286A5.689,5.689,0,0,1,6.906,3.142a.25.25,0,0,1,.35.31,4.06,4.06,0,0,0-.194.677.75.75,0,1,0,1.471.29,3.5,3.5,0,0,1,1.816-2.248.929.929,0,0,1,.352-.107.5.5,0,0,1,.549.5V4.5a.75.75,0,0,0,1.5,0V2.562a.5.5,0,0,1,.549-.5.929.929,0,0,1,.352.107,3.5,3.5,0,0,1,1.816,2.248.75.75,0,1,0,1.471-.29,4.06,4.06,0,0,0-.194-.677.25.25,0,0,1,.35-.31,5.689,5.689,0,0,1,2.972,3.263.251.251,0,0,1-.371.286l-.609-.375a2.233,2.233,0,0,0-2.567.414,2.23,2.23,0,0,1-3,.135,2.387,2.387,0,0,0-3.046,0,2.23,2.23,0,0,1-3-.135A2.233,2.233,0,0,0,4.914,6.316ZM15,12.25a3,3,0,1,1-3-3A3,3,0,0,1,15,12.25ZM7.481,17.27a2.232,2.232,0,0,1,3-.135,2.387,2.387,0,0,0,3.046,0,2.232,2.232,0,0,1,3,.135,2.235,2.235,0,0,0,2.567.415l.609-.375a.25.25,0,0,1,.371.285,5.686,5.686,0,0,1-2.972,3.263.25.25,0,0,1-.35-.31,4.033,4.033,0,0,0,.194-.677.75.75,0,1,0-1.471-.29,3.5,3.5,0,0,1-1.816,2.249.966.966,0,0,1-.352.107.5.5,0,0,1-.549-.5V19.5a.75.75,0,0,0-1.5,0v1.938a.5.5,0,0,1-.549.5.966.966,0,0,1-.352-.107,3.5,3.5,0,0,1-1.816-2.249.75.75,0,1,0-1.471.29,4.033,4.033,0,0,0,.194.677.25.25,0,0,1-.35.31A5.686,5.686,0,0,1,3.934,17.6a.25.25,0,0,1,.371-.285l.609.375A2.235,2.235,0,0,0,7.481,17.27Z', 'M10,12.25a.5.5,0,0,0,1,0,1,1,0,0,1,1-1,.5.5,0,0,0,0-1A2,2,0,0,0,10,12.25Z']],
  BusinessMagicRabbitHide: ['business-magic-rabbit-hide', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.612,15.184H6.86a.249.249,0,0,1,.245.3l-1.3,6.888a1.359,1.359,0,0,0,.309,1.143A1.422,1.422,0,0,0,7.2,24h9.312a1.421,1.421,0,0,0,1.078-.489,1.352,1.352,0,0,0,.309-1.143L16.6,15.48a.249.249,0,0,1,.246-.3h2.544a.98.98,0,0,0,0-1.959H4.612a.98.98,0,1,0,0,1.959Z', 'M19.837,3.34C21.306,1.87,18.857-1.068,16.9.4c-.9.672-2.9,3.769-3.634,4.935a.249.249,0,0,1-.278.107,3.471,3.471,0,0,0-1.972,0,.249.249,0,0,1-.278-.107C10,4.169,8,1.072,7.1.4,5.143-1.068,2.694,1.87,4.163,3.34c.767.766,3.326,2.727,4.406,3.546a.251.251,0,0,1,.064.327,3.9,3.9,0,0,0-.551,2,3.612,3.612,0,0,0,.579,1.956.253.253,0,0,0,.194.093H15.28a.253.253,0,0,0,.218-.127,4.436,4.436,0,0,0,.42-1.922,3.906,3.906,0,0,0-.55-2,.249.249,0,0,1,.063-.327C16.511,6.067,19.07,4.106,19.837,3.34ZM10.244,9.307a.735.735,0,1,1,.735-.736A.734.734,0,0,1,10.244,9.307Zm3.429,0a.735.735,0,1,1,.734-.736A.735.735,0,0,1,13.673,9.307Z']],
  BusinessHumanPlant: ['business-human-plant', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.888,9.364a10.212,10.212,0,0,0,3.68,8.845.238.238,0,0,1,.089.186v4.559a1,1,0,0,0,2,0V18.28a1.956,1.956,0,0,0-.736-1.52,8.3,8.3,0,0,1-3.04-7.216c.01-.126.025-.25.043-.373A1,1,0,1,0,.943,8.894C.922,9.05.9,9.207.888,9.364Z', 'M22.874,14.77a1.48,1.48,0,0,0,.209-1.322c-.163-.506-.322-1.015-.482-1.524-1.63-5.218-3.317-10.613-9.267-11.7A10.76,10.76,0,0,0,4.682,2.4,1,1,0,0,0,5.848,4.023a10.121,10.121,0,0,1,5.375-1.981c6.188-.02,7.776,5.063,9.469,10.479.09.285.282.855-.27.855H19.107a1,1,0,0,0-1,1v2.859a1.859,1.859,0,0,1-1.859,1.86h-.584a1.476,1.476,0,0,0-1.477,1.476v2.383a1,1,0,0,0,2,0v-1.77a.083.083,0,0,1,.061-.089,3.86,3.86,0,0,0,3.859-3.86V15.626a.25.25,0,0,1,.25-.25h1.324A1.482,1.482,0,0,0,22.874,14.77Z', 'M14.867 10.564 A1.250 1.250 0 1 0 17.367 10.564 A1.250 1.250 0 1 0 14.867 10.564 Z', 'M9.863,11.578a1,1,0,1,0,.793-1.836,3.507,3.507,0,0,0-4.6,1.822,3.5,3.5,0,0,0,1.822,4.6,1.063,1.063,0,0,0,1.315-.521,1,1,0,0,0-.52-1.315,1.5,1.5,0,1,1,1.192-2.753Z', 'M1.321,5.993a1,1,0,0,0,1,1H6.192a.252.252,0,0,1,.181.077L7.432,8.183a1.248,1.248,0,0,0,1.414.034.977.977,0,0,0,.215-1.1.09.09,0,0,1,.09-.122H10.38a.25.25,0,0,1,.181.077l1.06,1.113a1.26,1.26,0,0,0,1.413.034.977.977,0,0,0,.22-1.092.133.133,0,0,1,.131-.171h1.46a1,1,0,0,0,0-2H13.462a.157.157,0,0,1-.142-.184,1,1,0,0,0-1.682-.914L10.574,4.92a.249.249,0,0,1-.177.073H9.239c-.136,0-.136-.134-.119-.2a.981.981,0,0,0-.257-.935,1,1,0,0,0-1.414,0L6.386,4.92a.251.251,0,0,1-.177.073H2.321A1,1,0,0,0,1.321,5.993Z']]
};
exports["default"] = _default;